import {
  ContinentType,
  CookiePayload,
  CriteriaResponseType,
  ListType,
} from '@/app/types/constantDataType'
import { countryType } from '@/app/types/countryType'
import { apiSlice } from './apiSlice'
import { CookieConsentResponseData } from '@/app/types/cookieConsentType'

export const constantSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContienents: builder.query({
      query: () => ({
        url: '/countries/regions',
        method: 'GET',
      }),
      transformResponse: (responseData: ContinentType[]) => {
        return responseData?.filter((item) => item.name !== '')
      },
    }),
    getCountriesBasedOnCountinent: builder.query({
      query: ({ continetIds }: { continetIds: number[] }) => ({
        url: `/countries/by_region?regions[]${continetIds?.length > 0 ? '=' + continetIds.join(',') : ''}`,
        method: 'GET',
      }),
    }),
    getNewsSubDivisionList: builder.query<ListType[], { lang: string }>({
      query: ({ lang }) => ({
        url: `/news/retail_sub_division?lang=${lang}`,
      }),
    }),
    getVarietiesList: builder.query({
      query: ({
        varietySearchText,
        productId,
      }: {
        varietySearchText: string
        productId: number
      }) => ({
        url: `/varieties/search?name=${varietySearchText}&product=${productId}`,
      }),
    }),
    getCountries: builder.query({
      query: () => ({
        method: 'GET',
        url: `/countries`,
      }),
    }),
    getCountriesWithLang: builder.query({
      query: ({ language }: { language?: string }) => ({
        method: 'GET',
        url: `/countries?lang=${language}`,
      }),
      transformResponse: (responseData: countryType[]) => {
        return responseData?.map((item) => ({
          ...item,
          origin_type: 'Country',
        }))
      },
    }),
    getNewsCriteriaWithLang: builder.query({
      query: ({ language }: { language?: string }) => ({
        method: 'GET',
        url: `/news/criteria?lang=${language}`,
      }),
      transformResponse: (responseData: CriteriaResponseType) => {
        return responseData.criteria
      },
    }),
    getContientswithLang: builder.query<ListType[], { locale: string }>({
      query: ({ locale }) => ({
        method: 'GET',
        url: `/countries/regions?lang=${locale}`,
      }),
      transformResponse: (responseData: ListType[]) => {
        return responseData?.map((item) => ({ ...item, origin_type: 'Region' }))
      },
    }),
    getProductListBasedOnProductNameAndProductFamily: builder.query<
      ListType[],
      { productName: string; productFamily: string }
    >({
      query: ({ productName, productFamily }) => ({
        url: `/products/search?name=${productName}&product_family=${productFamily}`,
      }),
    }),
    getActivities: builder.query<ListType[], void>({
      query: () => ({
        method: 'GET',
        url: `/activities`,
      }),
    }),
    getUpdateCookieConsent: builder.mutation<{ status: string }, CookiePayload>(
      {
        query: ({ thirdParty, captcha }) => ({
          url: 'cookie_consent',
          method: 'POST',
          body: {
            cookie_consent: {
              google_analytics: thirdParty,
              captcha: captcha,
            },
          },
        }),
      }
    ),
    getCookieConsent: builder.query<CookieConsentResponseData, void>({
      query: () => ({
        url: 'cookie_consent',
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetContienentsQuery,
  useGetCountriesBasedOnCountinentQuery,
  useGetVarietiesListQuery,
  useGetCountriesQuery,
  useGetContientswithLangQuery,
  useGetCountriesWithLangQuery,
  useGetNewsCriteriaWithLangQuery,
  useGetNewsSubDivisionListQuery,
  useGetProductListBasedOnProductNameAndProductFamilyQuery,
  useGetActivitiesQuery,
  useGetUpdateCookieConsentMutation,
  useGetCookieConsentQuery,
} = constantSlice
